export default {
  path: '/wenjuan/:code',
  name: 'Wenjuan.Detail',
  component: () => import(/* webpackChunkName: "form" */ '@/views/modules/wenjuan/Detail.vue'),
  hiddenInMenu: true,
  meta: {
    title: '问卷详情',
    icon: 'database',
  },
};
